import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import "./sub-section.scss";

const block = "sub-section";

const SubSection = ({ className, headerText, children }) => {
  return (
    <section className={cn(className, block)}>
      <h3 className={`${block}__header`}>{headerText}</h3>
      {children}
    </section>
  );
};

SubSection.propTypes = {
  className: PropTypes.string,
  headerText: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

SubSection.defaultProps = {
  className: ""
};

export default SubSection;
